module.exports = __webpack_public_path__ + "assets/google_drive.61f08f15.svg";